import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ProjectCreateSF from '../../components/projectapp/project/ProjectCreateSF'

const ProjectCreatePageUI = ({context, messageList}) =>
  <PrivatePageSF context={context} className='pg_prj_crt' backLink='/projects'
    messageList={messageList} headerMessageKey='c_create_project'
  >
    <PageTitleUI context={context} goBack={true} backLink='/projects' messageList={messageList} titleMessageKey='c_create_project' />
    <ProjectCreateSF context={context} messageList={messageList} />
  </PrivatePageSF>

export default ProjectCreatePageUI
